.col {
  display: flex;
  flex-direction: column;
  gap: 0.5em;

  .start {
    align-items: flex-start;
  }
}

.minContent {
  width: min-content;
}


.iconBadge {
  height: 0.8em;
  width: auto;
  position: absolute;
  left: -1.2em;
  top: 0.4em;
}

.row {
  display: inline-flex;
  flex-direction: row;
  gap: 0.33em;
  align-items: center;

  &.sparse {
    gap: 0.66em;
  }
}

.gap1 {
  gap: 1em;
}

.withIcon {
	position: relative;

	> .icon {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateX(calc(-100% - 4px)) translateY(-50%);
    display: flex;
    /*align-items: center;
    justify-content: center;*/
	}

  &.compact {
    .icon {
      transform: translateX(calc(-100% - 2px)) translateY(-50%);
    }
  }
}

.withIconRight {
  display: inline-flex;
  gap: 0.25em;
}


.container {
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  
  &.center {
    align-items: center;
  }
}

.collapsible {
  display: grid;
  grid-template-rows: 1fr;
  transition: grid-template-rows 0.3s;
}

.collapsible.collapsed {
  grid-template-rows: 0fr;
}

.collapsible > * {
  overflow: hidden;
}
